export default __webpack_public_path__ + "static/media/error.ca85ab8f.svg";